import { render, staticRenderFns } from "./ProductSelectT5.vue?vue&type=template&id=bd866a4a&"
import script from "./ProductSelectT5.vue?vue&type=script&lang=js&"
export * from "./ProductSelectT5.vue?vue&type=script&lang=js&"
import style0 from "./ProductSelectT5.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports